import { render, staticRenderFns } from "./limit-details.vue?vue&type=template&id=20c53211&"
import script from "./limit-details.vue?vue&type=script&lang=js&"
export * from "./limit-details.vue?vue&type=script&lang=js&"
import style0 from "./limit-details.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports